import React from 'react';

// MUI components
import { Box, Typography, Card, CardContent, Avatar, Tooltip } from '@mui/material';

// Icons
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ScheduleIcon from '@mui/icons-material/Schedule';

// Images
import { ClockCircleCIcon, InfoCIcon } from '~/assets/images';
import OlcButton from '~/components/General/OlcButton';

// Styles
import './styles.scss';

const ProductTooltipContent = ({ product }) => (
  <div className="productTooltipContent">
    <Typography className="heading" variant="h4">
      {product?.title}
    </Typography>
    <div className="contentWrapper">
      {product?.size && (
        <Typography variant="h6">
          <span>Size:</span> {product?.size}
        </Typography>
      )}
      {product?.paper && (
        <Typography variant="h6">
          <span>Paper: </span> {product?.paper}{' '}
        </Typography>
      )}
      {+product?.id !== 2 && product?.envelope && (
        <Typography variant="h6">
          <span>Envelope: </span> {product?.envelope}{' '}
        </Typography>
      )}
      {+product?.id === 2 && product?.envelope && (
        <Typography variant="h6">
          <span>Windowed Envelope: </span> {product?.envelope}{' '}
        </Typography>
      )}
      {+product?.id === 2 && product?.nonEnvelope && (
        <Typography variant="h6">
          <span>Non-Windowed Envelope: </span> {product?.nonEnvelope}{' '}
        </Typography>
      )}
      {product?.ink && (
        <Typography variant="h6">
          <span>Ink: </span> {product?.ink}{' '}
        </Typography>
      )}
    </div>
  </div>
);

const AutomationSettingsPanel = ({
  COMPAIGNS_ACTION_TYPE,
  canAddActionFromSidebar,
  setSelectedActionType,
  setOpenActionDialog,
  setInsertIndex,
  setOpenDelayDialog,
  steps,
}) => {
  return (
    <Box className="automationSettingsPanel">
      <Typography variant="h6">Create Mail Campaign</Typography>
      {/* Add Actions Panel */}
      <Card
        className={
          canAddActionFromSidebar() ? 'actionsWrapper' : 'actionsWrapper delayStateWrapper'
        }
        sx={{
          backgroundColor: !canAddActionFromSidebar() ? '#F9FAFB' : 'transparent',
        }}
      >
        <CardContent
          sx={{
            p: '0 !important',
            width: '100%',
          }}
        >
          {canAddActionFromSidebar() ? (
            <>
              <Box
                className="actionsList"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                }}
              >
                {COMPAIGNS_ACTION_TYPE.filter(
                  (item) => ![4, 14, 15, 21, 11, 38].includes(+item.productId)
                ).map((action) => (
                  <Box
                    key={action.type}
                    className="actionItem"
                    onClick={() => {
                      setSelectedActionType(action.type);
                      setOpenActionDialog(true);
                      setInsertIndex(steps.length);
                    }}
                  >
                    <Avatar
                      sx={{
                        backgroundColor: 'transparent',
                        width: 60,
                        height: 60,
                        mr: 2,
                      }}
                    >
                      <img
                        src={action.icon}
                        alt={action.label}
                        style={{ width: '50%', height: '100%' }}
                      />
                    </Avatar>
                    <Box>
                      <Typography
                        variant="body1"
                        fontWeight="500"
                        sx={{ fontFamily: 'Inter', color: '#000' }}
                      >
                        {action.newLabel}
                      </Typography>
                      {/* <Typography variant="caption" sx={{ color: '#303030', fontFamily: 'Inter' }}>
                        {action.description}
                      </Typography> */}
                    </Box>
                    {/* <Tooltip title={<ProductTooltipContent product={action} />}>
                      <img
                        src={InfoCIcon}
                        alt="info"
                        style={{
                          position: 'absolute',
                          right: 10,
                          top: 10,
                          cursor: 'pointer',
                        }}
                      />
                    </Tooltip> */}
                  </Box>
                ))}
              </Box>
            </>
          ) : (
            <Box
              className="delayState"
              sx={{
                textAlign: 'center',
                py: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '24px',
              }}
            >
              <img
                src={ClockCircleCIcon}
                alt="clock-circle"
                style={{ width: '48px', height: '48px' }}
              />
              <Box>
                <Typography variant="h6" style={{ marginBottom: '8px' }}>
                  Add Delay First
                </Typography>
                <Typography>
                  You need to add a delay after the last action before adding another action
                </Typography>
              </Box>
              <OlcButton
                variant="primary"
                onClick={() => {
                  setOpenDelayDialog(steps.length);
                }}
              >
                Add Delay
              </OlcButton>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default AutomationSettingsPanel;
